import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { cx } from './cx.js';
export function OfflineBanner({ message = "You're offline. Reads continue from cache; writes are paused until you reconnect.", className, }) {
    const [isOnline, setIsOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    if (isOnline)
        return null;
    return (_jsx("div", { role: "alert", "aria-live": "polite", className: cx('fixed top-0 left-0 right-0 z-50', 
        // T4_6-010-PRE: Standard §5.8 warning treatment (theme-aware).
        'bg-[color-mix(in_srgb,var(--rr-state-warning)_15%,transparent)] text-rr-state-warning', 'border-b border-[var(--rr-state-warning)]', 'px-4 py-2 text-center text-sm font-medium', className), children: message }));
}
//# sourceMappingURL=OfflineBanner.js.map